import React from 'react'
import 'react-responsive-carousel/lib/styles/carousel.min.css'
import { Carousel } from 'react-responsive-carousel'
import Img from 'gatsby-image'
/**
 * Renders a Slider with Photos.
 *
 * @component
 *
 * return (
 *   <FotosSlider fotos={obj}/>
 * );
 */

const FotosSlider = ({ fotos }) => {
  return (
    <Carousel dynamicHeight swipeable emulateTouch showThumbs={false}>
      {fotos.map(foto => (
        <div key={foto.id}>
          {foto.localFile ? (
            <Img
              fluid={foto.localFile.childImageSharp.fluid}
              alt={foto.altText}
            />
          ) : (
            <img src={foto.sourceUrl} alt={foto.altText} />
          )}
        </div>
      ))}
    </Carousel>
  )
}

export default FotosSlider
